module.exports = __webpack_public_path__ + "15_hair_gold.487b9acd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/15_hair_gold.png
// module id = Bx6W
// module chunks = 0